(function () {
if (typeof window.StorefrontLayoutContext === 'undefined') {
  window.StorefrontLayoutContext = {};
}
if(typeof window.StorefrontLayoutExtensions === 'undefined'){
  window.StorefrontLayoutExtensions = {};
}

class SwymWishlistStorefrontLayout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.StorefrontLayoutType = StorefrontLayoutContext.Settings?.StorefrontLayoutType;
    this.renderUI();
    StorefrontLayoutExtensions.SwymStorefrontLayoutPageActions = document.querySelector('swym-storefront-layout-actions#swym-storefront-layout-actions-target-page');
  }

  renderUI(){
    let elementTag;
    switch (this.StorefrontLayoutType) {
      case 'as-drawer':
        elementTag = 'swym-storefront-layout-as-drawer';
        break;
      case 'as-section':
        elementTag = 'swym-storefront-layout-as-section';
        break;
      case 'as-modal':
        elementTag = 'swym-storefront-layout-as-modal';
        break;
      default:
        window._swat?.utils.error(`Unknown StorefrontLayoutType: ${this.StorefrontLayoutType}`);
        return;
    }
    
    this.innerHTML = `
        <${elementTag} ${this.StorefrontLayoutType==='as-section'?`container-id="${StorefrontLayoutContext.Settings.StorefrontLayoutAsSectionContainerId}"`:''}></${elementTag}>
        <swym-storefront-layout-notification id="swym-storefront-layout-notification" class="swym-storefront-layout-notification-position-${StorefrontLayoutContext.Settings?.StorefrontLayoutNotificationPosition}"></swym-storefront-layout-notification>
        <swym-storefront-layout-actions id="swym-storefront-layout-actions-target-page" class="swym-storefront-layout-action-for-wishlist-${this.StorefrontLayoutType} swym-storefront-layout-action-popup-position-${StorefrontLayoutContext.Settings?.StorefrontLayoutActionPopupPosition}"></swym-storefront-layout-actions>
        <swym-storefront-layout-action-tooltip id="swym-storefront-layout-action-tooltip-target-page" class="swym-storefront-layout-action-tooltip-for-wishlist-${this.StorefrontLayoutType}"></swym-storefront-layout-action-tooltip>
      `
      this.classList.add(`${elementTag}`);
  }

}

customElements.define('swym-storefront-layout', SwymWishlistStorefrontLayout);
})();